import './index.scss';

const Loader = ({ darkBackground, className, ...props }) => {
    return <div className={`loader ${darkBackground ? 'dark-background' : ''} ${className ? className : ''}`} {...props} />;
};

export default Loader;